/*
<summary>
   This enum defines the tool_master.calibration_status values.
   Developer: Aashish Singh, Created Date: 25-Aug-2026
</summary>
*/
enum CalibrationStatusEnum {
  Valid = 0,
  Warning = 1,
  Expired = 2,
}

export default CalibrationStatusEnum;
